import React, { useCallback, useEffect, useMemo, useState } from "react";
import SearchBootstrapTable from "app/Components/BootstrapTable/SearchBootstrapTable";
import { Link } from "react-router-dom";
import { FiEdit3, FiEye } from "react-icons/fi";
import { ACTIVE_MODULE } from "app/_constants/constant";
import ToolkitProvider, {
  Search,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";

import BackBtn from "app/Components/CommanComponents/BackBtn";

import CustomTooltip from "app/Components/CommanComponents/CustomTooltip";
import { deleteVFL, getVFL, revertedExecutive } from "app/_services/ehs/VFLService";
import {
  isUserMM,
  isUserSO,
  isUserVFLOfficer,
  IS_USER_SITE_HO,
  LOGGED_IN_USER_SITE_ID,
  LOGGED_USER_ID,
} from "../IncidentManagement/Helper";
import { SITE_TYPE } from "app/_constants/constant";
import {
  checkVflStatusFilter,
  getVFLStatusClass,
  incidentFilterFields,
  VFL_STATUS,
  VFL_STATUS_COLUMN,
  VFL_STATUS_VIEW,
} from "./CONSTANTS";
import { FaRegTrashAlt } from "react-icons/fa";
import { confirmAlert } from "react-confirm-alert";
import toastr from "toastr";
import VFLFilters from "./component/VFLFilters";
import { useForm } from "app/_helpers/hooks";
import { validateRowFilter } from "../IncidentManagement/CONSTANTS";
import { DDMMYYYYHHMMAFormat, isBetween, YYYYMMDDFormat } from "app/_helpers/dateHelper";
import { formatDDMMYYYYbyYYYYMMDD, paginationOptionsObj } from "app/_helpers/helper";
import FilterBtn from "app/Components/CommanComponents/FilterBtn";
import paginationFactory from "react-bootstrap-table2-paginator";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import MainBreadcrumb from "app/views/custom/components/MainBreadcrumb";
import Decline from "../IncidentManagement/DeclinePopup";
import { MdRefresh } from "react-icons/md";
import NetZeroLoader from "app/views/custom/components/Loader/NetZeroLoader";

const { SearchBar } = Search;

function MyApprovalActionVFL() {
  const [tab, setTab] = useState(
    isUserSO() ? 1 : isUserMM() ? 2 : isUserVFLOfficer() ? 3 : 0
  );
  const [VFLList, setVFLList] = useState([]);
  const [tableVFLList, setTableVFLList] = useState([]);
  const [filterForm, onChangeFilter, setFilterForm] = useForm({}, incidentFilterFields);
  const [VFLFilter, setVFLFilter] = useState([]);
  const [showFilter, setShowFilter] = useState(false);
  const [loading, setLoading] = useState(true);

  const deleteRow = useCallback(async (e, id) => {
    e.preventDefault();

    confirmAlert({
      title:
        "You have chosen to delete a previously assigned VFL. If you continue, it will be permanently deleted",
      message: "Do you want to proceed?",
      buttons: [
        {
          label: "Yes",
          onClick: async () => {
            if (window.confirm("Are you Sure Y/N")) {
              let response = await deleteVFL(id);

              if (!response?.status) return toastr.info(response?.message);

              toastr.info(response?.message || "Deleted Successfully!");
              getVflList();
            }
          },
        },
        {
          label: "No",
          onClick: () => {},
        },
      ],
    });
  }, []);

  const revertExecutive = (id, obj) => {
    revertedExecutive(id, obj).then((response) => {
      if (response?.status) {
        toastr.success("Returned Successfully");
        getVflList();
      }
    });
  };
  const rowStyle = (row) => {
    if (row?.executiveReturn) {
      return { backgroundColor: "#d2ced6" };
    }
  };
  const sortableColumn = useMemo(
    () => [
      {
        dataField: "sid",
        text: "S.No.",
        sort: true,
      },
      {
        dataField: "vflId",
        text: "VFL Id",
        sort: true,
        formatter: (vflId, row) => (
          <OverlayTrigger
            placement="top"
            overlay={<Tooltip id="tooltip-top">View</Tooltip>}
          >
            <Link
              className="icons text-cyanBlue"
              to={
                row.vflStatus === VFL_STATUS.completed
                  ? "/health-safety-and-environment/vfl/completion/view/" + row.id
                  : "/health-safety-and-environment/vfl/view/" + row.id
              }
            >
              {vflId}
            </Link>
          </OverlayTrigger>
        ),
      },
      // {
      //   dataField: "vflScheduledDateTimeView",
      //   text: "VFL Scheduled Date",
      //   sort: true,
      // },
      {
        dataField: "mineName",
        text: "Location Name ",
        sort: true,
      },
      {
        dataField: "siteData.siteId",
        text: "Location Code",
        sort: true,
        formatter: (ehsSite, row) => {
          return (
            <span title={row?.siteData ? row?.siteData?.name : ""}>
              {row?.siteData ? row?.siteData?.siteId : ""}
            </span>
          );
        },
      },
      {
        dataField: "vflExecutiveName",
        text: "VFL Executive",
        sort: true,
      },
      {
        dataField: "ehs_area_of_operations.name",
        text: "Area",
        sort: true,
      },
      {
        dataField: "departmentId",
        text: "Department",
        sort: true,
      },
      {
        dataField: "contractorInvolved",
        text: "Contractor",
        sort: true,
        formatter: (contractorInvolved) => {
          return contractorInvolved ? "Yes" : "No";
        },
      },
      {
        dataField: "vflStatusView",
        text: "Status",
        sort: true,
        formatter: (status, row) => {
          return VFL_STATUS_COLUMN(row?.vflStatus, row);
        },
      },
      {
        dataField: "createdAt",
        text: "Time Stamp",
        sort: true,
        formatter: (createdAt, row) => {
          return DDMMYYYYHHMMAFormat(createdAt);
        },
      },
      {
        dataField: "create",
        text: "Action",
        formatter: (rowContent, row) => {
          let editLink = null;
          let returnIcon = null;
          if (row.vflStatus) {
            if (
              row.vflStatus === "scheduled" &&
              isUserMM() &&
              ((row.vflAssignerSiteType === SITE_TYPE.ho && IS_USER_SITE_HO()) ||
                (row.vflAssignerSiteType === SITE_TYPE.mines &&
                  LOGGED_IN_USER_SITE_ID() === row.mineId))
            ) {
              editLink = "/health-safety-and-environment/vfl/schedule/" + row.id;
            } else if (
              [VFL_STATUS.assigned, VFL_STATUS.executed, VFL_STATUS.overdue].includes(
                row.vflStatus
              ) &&
              isUserVFLOfficer() &&
              LOGGED_USER_ID() === row.vflExecutiveId
            ) {
              editLink = "/health-safety-and-environment/vfl/completion/" + row.id;
              returnIcon = true;
            } else if (
              row.vflStatus === VFL_STATUS.capaCompleted &&
              isUserSO() &&
              ((row.vflAssignerSiteType === SITE_TYPE.ho && IS_USER_SITE_HO()) ||
                (row.vflAssignerSiteType === SITE_TYPE.mines &&
                  LOGGED_IN_USER_SITE_ID() === row.mineId))
            ) {
              editLink = "/health-safety-and-environment/vfl/so-completion/" + row.id;
            } else if (
              row.vflStatus === VFL_STATUS.capaReviewed &&
              isUserMM() &&
              ((row.vflAssignerSiteType === SITE_TYPE.ho && IS_USER_SITE_HO()) ||
                (row.vflAssignerSiteType === SITE_TYPE.mines &&
                  LOGGED_IN_USER_SITE_ID() === row.mineId))
            ) {
              editLink = "/health-safety-and-environment/vfl/mm-completion/" + row.id;
            } else if (
              (row.vflStatus === VFL_STATUS.draft ||
                row.vflStatus === VFL_STATUS.rejected) &&
              isUserSO() &&
              ((row.vflAssignerSiteType === SITE_TYPE.ho && IS_USER_SITE_HO()) ||
                (row.vflAssignerSiteType === SITE_TYPE.mines &&
                  LOGGED_IN_USER_SITE_ID() === row.mineId))
            ) {
              editLink = "/health-safety-and-environment/vfl/schedule/" + row.id;
            }
          }

          let deleteLink = false;
          if (
            row.vflStatus &&
            [VFL_STATUS.scheduled, VFL_STATUS.assigned].includes(row.vflStatus) &&
            isUserMM() &&
            !row?.executiveReturn
          ) {
            if (
              (row.vflAssignerSiteType === SITE_TYPE.ho && IS_USER_SITE_HO()) ||
              (row.vflAssignerSiteType === SITE_TYPE.mines &&
                LOGGED_IN_USER_SITE_ID() === row.mineId)
            )
              deleteLink = true;
          }

          return (
            <div className="actionIconsGroup">
              <CustomTooltip tooltip={"View"}>
                <Link
                  to={"/health-safety-and-environment/vfl/view/" + row.id}
                  className="icons text-cyanBlue"
                >
                  <FiEye />
                </Link>
              </CustomTooltip>

              {editLink && (
                <CustomTooltip tooltip={"Edit"}>
                  <Link to={editLink} className="icons text-cyanBlue">
                    <FiEdit3 />
                  </Link>
                </CustomTooltip>
              )}

              {returnIcon && !row?.vflCompletionDateTime && (
                <Decline
                  onSubmit={(obj) =>
                    revertExecutive(row?.id, { revertMessage: obj.comment })
                  }
                  title="Return"
                  name={
                    <CustomTooltip tooltip="Return">
                      <MdRefresh size={20} />
                    </CustomTooltip>
                  }
                  iconClass={"icons text-cyanBlue"}
                />
              )}
              {deleteLink && (
                <CustomTooltip tooltip={"Delete"}>
                  <span
                    onClick={(e) => deleteRow(e, row.id)}
                    className="icons text-danger pointer"
                  >
                    <FaRegTrashAlt />
                  </span>
                </CustomTooltip>
              )}
            </div>
          );
        },
      },
    ],
    [deleteRow]
  );

  const onReset = () => setFilterForm({});

  /**************** useEffect *************/
  useEffect(() => {
    getVflList();
  }, []);

  const getVflList = async () => {
    // getVFL().then((response) => {
    //   if (!response?.status) return;
    //   setVFLList(response.data);
    // });

    const response = await getVFL();

    if (!response?.data) {
      // Handle the case where data is not received
      setLoading(false);
      return;
    }
    setVFLList(response.data);
    setLoading(false);
  };

  useEffect(() => {
    let result = VFLList.filter((row) => {
      let flag = false;
      if (row.vflStatus) {
        if (
          tab === 2 &&
          row.vflStatus === "scheduled" &&
          !row?.executiveReturn &&
          isUserMM() &&
          ((row.vflAssignerSiteType === SITE_TYPE.ho && IS_USER_SITE_HO()) ||
            (row.vflAssignerSiteType === SITE_TYPE.mines &&
              LOGGED_IN_USER_SITE_ID() === row.mineId))
        ) {
          flag = true;
        } else if (
          tab === 3 &&
          [VFL_STATUS.assigned, VFL_STATUS.executed, VFL_STATUS.overdue].includes(
            row.vflStatus
          ) &&
          isUserVFLOfficer() &&
          LOGGED_USER_ID() === row.vflExecutiveId
        ) {
          flag = true;
        } else if (
          tab === 1 &&
          (row.vflStatus === VFL_STATUS.capaCompleted ||
            (row.vflStatus === VFL_STATUS.scheduled && row?.executiveReturn)) &&
          isUserSO() &&
          ((row.vflAssignerSiteType === SITE_TYPE.ho && IS_USER_SITE_HO()) ||
            (row.vflAssignerSiteType === SITE_TYPE.mines &&
              LOGGED_IN_USER_SITE_ID() === row.mineId))
        ) {
          flag = true;
        } else if (
          tab === 2 &&
          row.vflStatus === VFL_STATUS.capaReviewed &&
          isUserMM() &&
          ((row.vflAssignerSiteType === SITE_TYPE.ho && IS_USER_SITE_HO()) ||
            (row.vflAssignerSiteType === SITE_TYPE.mines &&
              LOGGED_IN_USER_SITE_ID() === row.mineId))
        ) {
          flag = true;
        } else if (
          tab === 1 &&
          (row.vflStatus === VFL_STATUS.draft || row.vflStatus === VFL_STATUS.rejected) &&
          isUserSO() &&
          ((row.vflAssignerSiteType === SITE_TYPE.ho && IS_USER_SITE_HO()) ||
            (row.vflAssignerSiteType === SITE_TYPE.mines &&
              LOGGED_IN_USER_SITE_ID() === row.mineId))
        ) {
          flag = true;
        } else if (
          tab === 4 &&
          row.vflStatus === VFL_STATUS.scheduled &&
          row?.executiveReturn &&
          isUserSO() &&
          ((row.vflAssignerSiteType === SITE_TYPE.ho && IS_USER_SITE_HO()) ||
            (row.vflAssignerSiteType === SITE_TYPE.mines &&
              LOGGED_IN_USER_SITE_ID() === row.mineId))
        ) {
          flag = true;
        }
      }

      return flag;
    });

    setTableVFLList(
      result.map((d, i) => ({
        ...d,
        sid: i + 1,
        vflStatusView: !d?.executiveReturn
          ? VFL_STATUS_VIEW[d?.vflStatus]
          : VFL_STATUS_VIEW?.ExecutiveReturn,
        vflExecutiveName: d?.vflOfficerData
          ? `${d?.vflOfficerData?.firstName} ${d?.vflOfficerData?.lastName}`
          : "",
      }))
    );
  }, [VFLList, tab]);

  useEffect(() => {
    if (filterForm.hasOwnProperty("contractorInvolved")) {
      if (filterForm.contractorInvolved === "") filterForm.contractorInvolved = 0;
    }
    setVFLFilter(
      tableVFLList?.filter?.((data) => {
        let flag = true;
        if (filterForm?.startDate && filterForm?.endDate) {
          flag = isBetween(
            data.vflScheduledDateTime,
            YYYYMMDDFormat(filterForm.startDate),
            YYYYMMDDFormat(filterForm.endDate)
          );
        }

        if (filterForm?.vflStatus && flag) {
          flag = checkVflStatusFilter(filterForm?.vflStatus, data);
        }

        if (flag) flag = validateRowFilter(filterForm, data);
        return flag;
      })
    );
  }, [filterForm, tableVFLList]);

  console.log("filterForm", filterForm);
  const tableToolbarBeforeView = () =>
    showFilter && (
      <VFLFilters
        fields={incidentFilterFields}
        setForm={setFilterForm}
        form={filterForm}
        onChange={onChangeFilter}
        onReset={onReset}
      />
    );

  return (
    <>
      <MainBreadcrumb
        routeSegments={[
          { name: "Health Safety And Environment", path: "#" },
          {
            name: "Visible Felt Leadership",
            path: "/health-safety-and-environment/vfl",
          },
          { name: "My Approval Actions" },
        ]}
        module={ACTIVE_MODULE.vfl}
      />
      <div className="card p-3">
        <div className="simple-card-title cardCustomHeader">
          <h3 class="text-capitalize mb-1">My Approval Actions</h3>
          <FilterBtn setShowFilter={setShowFilter} />
          <BackBtn url={"/health-safety-and-environment/vfl"} />
        </div>

        <div className="healthSafetyEnvironmentWrapper EHS_module_tabber mb-3">
          <div className="hseMenuLinks card">
            {isUserSO() && (
              <a
                href
                onClick={() => setTab(1)}
                className={`pointer${tab === 1 ? " active" : ""}`}
              >
                {(IS_USER_SITE_HO() && "Head Safety") || "Safety Officer"}
              </a>
            )}

            {isUserMM() && (
              <a
                href
                onClick={() => setTab(2)}
                className={`pointer${tab === 2 ? " active" : ""}`}
              >
                {(IS_USER_SITE_HO() && "Mines Manager - HO") || "Mines Manager"}
              </a>
            )}
            {isUserVFLOfficer() && (
              <a
                href
                onClick={() => setTab(3)}
                className={`pointer${tab === 3 ? " active" : ""}`}
              >
                VFL Executive
              </a>
            )}
            {/* {isUserSO() && (
              <a
                href
                onClick={() => setTab(4)}
                className={`pointer${tab === 4 ? " active" : ""}`}
              >
                Executive Returned
              </a>
            )} */}
          </div>
        </div>

        {/* <ToolkitProvider
          striped
          keyField="id"
          data={VFLFilter} */}
        {/* columns={sortableColumn} */}
        {/* search={{
          //   defaultSearch: filterStatus?.manageIncidentSearch,
          // }} */}
        {/* > */}
        {/* {(props) => (
            <> */}
        {/* {showFilter && (
                <VFLFilters
                  fields={incidentFilterFields}
                  setForm={setFilterForm}
                  form={filterForm}
                  onChange={onChangeFilter}
                  onReset={onReset}
                />
              )} */}

        {/* <div className="d-flex align-items-center justify-content-between pb-3"> */}
        {/* <SearchBar {...props.searchProps} className="mb-0" /> */}
        {/* <div className="btn-toolbar"></div>
              </div> */}

        {/* <div className="material-master-table incidentTable"> */}
        {/* <BootstrapTable
                  {...props.baseProps}
                  bootstrap4
                  noDataIndication={"Table is empty"}
                  pagination={paginationFactory({
                    ...paginationOptionsObj,
                    totalSize: Array.isArray(VFLFilter) ? VFLFilter.length : 0,
                  })}
                /> */}
        {!loading ? (
          <SearchBootstrapTable
            rowStyle={rowStyle}
            searchKey={"myApprovalActionVFLDesktopSearch"}
            data={VFLFilter}
            columns={sortableColumn}
            tableBeforeSearch={tableToolbarBeforeView}
            tableKey="myApprovalActionVFL"
            defaultHideColumn={["mineName"]}
          />
        ) : (
          <NetZeroLoader />
        )}

        {/* </div> */}
        {/* </> */}
        {/* )} */}
        {/* </ToolkitProvider> */}
      </div>
    </>
  );
}

export default MyApprovalActionVFL;
